<mat-toolbar color="accent" *ngIf="this.mode === 'detail'">
  <button id="goBack" mat-icon-button (click)="goBack()">
    <mat-icon class="icon-ic_arrow_back" color="secundary"></mat-icon>
  </button>
  <span translate>detailUser.back.title</span>
</mat-toolbar>
<mat-card>
  <h2>
    {{ this.mode === 'detail' ? ('detailUser.title' | translate) : ('createUser.title' | translate) }}
  </h2>
  <mat-card-content>
    <p>{{ (this.mode === 'detail' ? 'create.card.subtitle2' : 'create.card.subtitle') | translate }}</p>
    <mat-grid-list cols="16" rowHeight="10px">
      <form [formGroup]="userCharacteristicsForm">
        <mat-grid-tile colspan="7" rowspan="6">
          <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
            <mat-label>{{ 'create.user' | translate }}</mat-label>
            <input
              id="nameRegister"
              formControlName="user"
              matInput
              type="text"
              (focusout)="onFocusOutEvent($event)"
              maxlength="11"
              autocomplete="off"
            />
            <mat-error *ngIf="userCharacteristicsForm.controls.user.errors?.userExist">{{
              'create.userExist' | translate
            }}</mat-error>
            <mat-error *ngIf="userCharacteristicsForm.controls.user.hasError('required')" translate>
              field.required
            </mat-error>
            <mat-error
              *ngIf="
                userCharacteristicsForm.controls.user.invalid &&
                !userCharacteristicsForm.controls.user.errors?.userExist &&
                !userCharacteristicsForm.controls.user.hasError('required')
              "
              translate
            >
              field.incorrect
            </mat-error>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="3" rowspan="6">
          <p class="iconOk" *ngIf="!userCharacteristicsForm.controls.user.errors?.userExist && !userExist">
            <mat-icon>check</mat-icon><span>{{ 'create.available' | translate }}</span>
          </p>
          <p class="iconClose" *ngIf="userCharacteristicsForm.controls.user.errors?.userExist">
            <mat-icon>close</mat-icon><span>{{ 'create.card.notAvailable' | translate }}</span>
          </p>
        </mat-grid-tile>

        <mat-grid-tile colspan="3" rowspan="6"></mat-grid-tile>

        <mat-grid-tile colspan="7" rowspan="6">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="radioButtonType"
            [id]="'radioButtonType'"
            [dataInput]="userTypesList"
            [placeholder]="'create.userType'"
            [showErrors]="userCharacteristicsForm?.controls?.radioButtonType?.errors"
            (selectionChange)="updateActionUser()"
          ></scf-custom-select-search>
        </mat-grid-tile>

        <mat-grid-tile
          *ngIf="
            this.actionUser === 'US' ||
            userCharacteristicsForm.controls.radioButtonType.value === 'Y' ||
            userCharacteristicsForm.controls.radioButtonType.value === 'Z' ||
            userCharacteristicsForm.controls.radioButtonType.value === 'X'
          "
          colspan="9"
          rowspan="6"
        ></mat-grid-tile>

        <mat-grid-tile
          *ngIf="
            (this.actionUser === 'US' && !userCommercial) ||
            userCharacteristicsForm.controls.radioButtonType.value === 'Y' ||
            userCharacteristicsForm.controls.radioButtonType.value === 'Z' ||
            userCharacteristicsForm.controls.radioButtonType.value === 'X'
          "
          colspan="3"
          rowspan="6"
        >
          <scf-custom-select-search
            fxFlex="100"
            formControlName="division"
            [id]="'division'"
            [dataInput]="userDivisionList"
            [placeholder]="'create.division'"
            [isRequired]="true"
            [showErrors]="userCharacteristicsForm?.controls?.division?.errors"
            (selectionChange)="onDivisionSelection()"
          ></scf-custom-select-search>
        </mat-grid-tile>

        <mat-grid-tile
          *ngIf="this.actionUser === 'US' && !userCommercial && this.mode !== 'detail'"
          colspan="7"
          rowspan="6"
        >
          <scf-custom-select-search
            fxFlex="100"
            formControlName="externalComercial"
            [id]="'externalComercial'"
            [dataInput]="externalComercialList"
            [placeholder]="'create.externalComercial'"
            [isRequired]="true"
            [showErrors]="userCharacteristicsForm?.controls?.externalComercial?.errors"
            (selectionChange)="reset()"
          ></scf-custom-select-search>
        </mat-grid-tile>

        <mat-grid-tile
          *ngIf="this.actionUser === 'WB' && userCharacteristicsForm.controls.radioButtonType.value === 'Z'"
          colspan="7"
          rowspan="6"
        >
          <scf-custom-select-search
            fxFlex="100"
            formControlName="offices"
            [id]="'offices'"
            [dataInput]="officeList"
            [placeholder]="'create.offices'"
            [isRequired]="true"
            [isMultiple]="true"
            [showErrors]="userCharacteristicsForm?.controls?.offices?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>

        <mat-grid-tile
          *ngIf="this.actionUser === 'WB' && userCharacteristicsForm.controls.radioButtonType.value === 'X'"
          colspan="7"
          rowspan="6"
        >
          <scf-custom-select-search
            fxFlex="100"
            formControlName="chains"
            [id]="'chains'"
            [dataInput]="chainList"
            [placeholder]="'create.chains'"
            [isRequired]="true"
            [isMultiple]="true"
            [showErrors]="userCharacteristicsForm?.controls?.chains?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>

        <mat-grid-tile
          *ngIf="(this.actionUser === 'US' || this.actionUser === 'CO') && !userCommercial"
          colspan="6"
          rowspan="6"
        ></mat-grid-tile>

        <mat-grid-tile
          *ngIf="this.actionUser === 'WB' && !userCommercial"
          [colspan]="userCharacteristicsForm.controls.radioButtonType.value === 'Y' ? 8 : 6"
          rowspan="6"
        ></mat-grid-tile>

        <mat-grid-tile *ngIf="this.actionUser === 'WB'" colspan="7" rowspan="6">
          <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
            <mat-label>{{ 'create.name' | translate }}</mat-label>
            <input id="nameWebService" formControlName="nameWebService" matInput type="text" autocomplete="off" />
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile *ngIf="this.actionUser === 'WB'" colspan="9" rowspan="6"></mat-grid-tile>

        <mat-grid-tile *ngIf="this.actionUser === 'WB'" colspan="16" rowspan="3" class="webService">
          <mat-checkbox
            id="checkUserWebService"
            color="primary"
            [checked]="checked"
            (change)="checked = !checked"
            color="accent"
            aria-label="Usuario web services"
            name="checkUserWebService"
            (change)="onChangeWebService($event)"
            formControlName="checkUserWebService"
          >
            <span>{{ 'create.userWeb' | translate }}</span>
          </mat-checkbox>
        </mat-grid-tile>

        <div *ngIf="this.userCharacteristicsForm.controls.checkUserWebService.value">
          <mat-grid-tile colspan="16" rowspan="6" class="text">
            <div>
              <p>
                <strong>{{ 'create.passwordUser' | translate }}</strong>
              </p>
              <span>{{ 'create.password2' | translate }}</span>
            </div>
          </mat-grid-tile>

          <mat-grid-tile colspan="6" rowspan="6">
            <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
              <mat-label>{{ 'create.password' | translate }}</mat-label>
              <input
                id="passwordWebService"
                formControlName="passwordWebService"
                matInput
                type="text"
                autocomplete="off"
              />
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile colspan="10" rowspan="6"></mat-grid-tile>
        </div>

        <mat-grid-tile *ngIf="this.actionUser !== 'WB'" colspan="16" rowspan="6" class="text">
          <button
            id="searchUser"
            mat-stroked-button
            type="button"
            color="accent"
            (click)="openDialog()"
            [disabled]="
              !this.userCharacteristicsForm.controls.radioButtonType.value ||
              !this.userCharacteristicsForm.controls.user.value
            "
          >
            <mat-icon class="icon-ic_search"></mat-icon>
            <span>{{ 'search.button.search' | translate | uppercase }}</span>
          </button>
        </mat-grid-tile>

        <div *ngIf="userInfoDetail && this.actionUser !== 'WB'">
          <mat-grid-tile colspan="8" rowspan="28" class="userInfoDetail">
            <p>
              <strong>{{ 'create.userSelected' | translate }}</strong
              >{{ userInfoDetail.userDesc }}
            </p>
            <p>
              <strong>{{ 'create.commercial' | translate }}</strong>

              {{
                userDetail?.internalCommercialDesc
                  ? userDetail.internalCommercialDesc === 'detail.user.tooManyData'
                    ? translateService.instant('createUser.detail.user.tooManyData')
                    : userDetail.internalCommercialDesc
                  : userDetail.userType === 'I'
                  ? userInfoDetail.userDesc
                  : ''
              }}
            </p>
            <p>
              <strong>{{ 'create.chain' | translate }}</strong>
              {{
                userDetail?.chainDesc
                  ? userDetail.chainDesc
                  : userDetail.userType === 'C'
                  ? userInfoDetail.userDesc
                  : ''
              }}
            </p>
            <p>
              <strong>{{ 'create.presciptor' | translate }}</strong>
              {{
                userDetail?.prescriberDesc
                  ? userDetail.prescriberDesc
                  : userDetail.userType === 'P'
                  ? userInfoDetail.userDesc
                  : ''
              }}
            </p>
            <p>
              <strong>{{ 'create.establishment' | translate }}</strong
              >{{
                userDetail?.establishmentDesc
                  ? userDetail.establishmentDesc
                  : userDetail.userType === 'E'
                  ? userInfoDetail.userDesc
                  : ''
              }}
            </p>
            <p>
              <strong>{{ 'create.host' | translate }}</strong> {{ userDetail?.userId }}
            </p>
            <p>
              <strong>{{ 'create.division' | translate }}</strong
              >{{ userInfoDetail.division }}
            </p>
            <p>
              <strong>{{ 'create.highDate' | translate }}</strong
              >{{ userInfoDetail.registerDate }}
            </p>
            <p></p>
          </mat-grid-tile>

          <mat-grid-tile *ngIf="userInfoDetail" colspan="8" rowspan="28" class="userInfoDetail">
            <p>
              <strong>{{ 'create.nif' | translate }}</strong
              >{{ userInfoDetail.nif }}
            </p>
            <p>
              <strong>{{ 'create.commercialExternal' | translate }}</strong>
              {{
                userDetail?.externalCommercialDesc
                  ? userDetail.externalCommercialDesc === 'detail.user.tooManyData'
                    ? translateService.instant('createUser.detail.user.tooManyData')
                    : userDetail.externalCommercialDesc
                  : userDetail.userType === 'O'
                  ? userInfoDetail.userDesc
                  : ''
              }}
            </p>
            <p>
              <strong>{{ 'create.address' | translate }}</strong
              >{{ userInfoDetail.address }}
            </p>
            <p>
              <strong>{{ 'create.population' | translate }}</strong
              >{{ userInfoDetail.city }}
            </p>
            <p>
              <strong>{{ 'create.province' | translate }}</strong> {{ userDetail.province }}
            </p>
            <p>
              <strong>{{ 'create.postalCode' | translate }}</strong
              >{{ userInfoDetail.zipCode }}
            </p>
            <p>
              <strong>{{ 'create.phone' | translate }}</strong
              >{{ userInfoDetail.phone }}
            </p>
            <p>
              <strong>{{ 'create.email' | translate }}</strong
              >{{ userInfoDetail.email }}
            </p>
            <p></p>
          </mat-grid-tile>
        </div>

        <mat-grid-tile
          *ngIf="
            this.userCharacteristicsForm.controls.radioButtonType.value === 'V' &&
            userInfoDetail &&
            this.mode !== 'detail'
          "
          colspan="8"
          rowspan="6"
        >
          <scf-custom-select-search
            fxFlex="100"
            formControlName="vendor"
            [id]="'vendor'"
            [dataInput]="vendorsList"
            [placeholder]="'create.vendor'"
            [isRequired]="true"
            [showErrors]="userCharacteristicsForm?.controls?.vendor?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>

        <mat-grid-tile
          *ngIf="
            this.userCharacteristicsForm.controls.radioButtonType.value === 'V' &&
            userInfoDetail &&
            this.mode !== 'detail'
          "
          colspan="4"
          rowspan="6"
        ></mat-grid-tile>

        <div *ngIf="userInfoDetail || this.actionUser === 'WB'">
          <mat-grid-tile colspan="7" rowspan="6">
            <scf-custom-select-search
              fxFlex="100"
              formControlName="perfil"
              [id]="'perfil'"
              [dataInput]="userProfilesList"
              [placeholder]="'create.profileSelected'"
              [isRequired]="true"
              [showErrors]="userCharacteristicsForm?.controls?.perfil?.errors"
              (selectionChange)="loadListAttributions()"
            ></scf-custom-select-search>
          </mat-grid-tile>
        </div>

        <mat-grid-tile colspan="1" rowspan="6"></mat-grid-tile>

        <mat-grid-tile
          *ngIf="this.actionUser === 'US' && userDetail && userInfoDetail && showBrand"
          colspan="8"
          class="userInfoDetail"
          rowspan="6"
        >
          <p>
            <strong>{{ 'create.brand' | translate }}: </strong> {{ userDetail?.brand }}
          </p>
          <!-- <scf-custom-select-search
            fxFlex="100"
            formControlName="brand"
            [id]="'brand'"
            [dataInput]="brandList"
            [placeholder]="'create.brand'"
            [isRequired]="true"
            [showErrors]="userCharacteristicsForm?.controls?.brand?.errors"
          ></scf-custom-select-search> -->
        </mat-grid-tile>

        <!-- <mat-grid-tile *ngIf="this.actionUser === 'US' && userInfoDetail && showBrand" colspan="2" rowspan="6">
        </mat-grid-tile> -->
        <mat-grid-tile *ngIf="this.actionUser === 'WB'" colspan="9" rowspan="6"></mat-grid-tile>

        <mat-grid-tile colspan="16" [rowspan]="checkboxRows()" *ngIf="hasLoadedAtributions()">
          <div fxFlex="100" fxLayout="column" formGroupName="atributions" class="atribution-box">
            <mat-label class="atribution-box-title"><strong translate>edit.atribution</strong></mat-label>
            <div fxFlex="100" fxLayout="row wrap">
              <div fxFlex="32" *ngFor="let atribution of attributionList">
                <mat-checkbox
                  fxFlex="100"
                  id="atribution{{ atribution.id }}RegisterWebUser"
                  color="accent"
                  [formControlName]="atribution.id"
                >
                  {{ atribution.name }}
                </mat-checkbox>
              </div>
            </div>
          </div>
        </mat-grid-tile>

        <div *ngIf="(isWebUser && mode === 'detail') || mode !== 'detail'">
          <mat-grid-tile *ngIf="this.actionUser === 'WB' || userInfoDetail" colspan="10" rowspan="6" class="text">
            <div>
              <p>
                <strong>{{ 'create.emailUser' | translate }}</strong>
              </p>
              <span>{{ 'create.emailUser2' | translate }}</span>
            </div>
          </mat-grid-tile>

          <mat-grid-tile *ngIf="this.actionUser === 'WB' || userInfoDetail" colspan="6" rowspan="6"></mat-grid-tile>

          <mat-grid-tile *ngIf="this.actionUser === 'WB' || userInfoDetail" colspan="7" rowspan="6">
            <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
              <mat-label>{{ 'create.emailUser3' | translate }}</mat-label>
              <input id="email" formControlName="email" matInput type="text" autocomplete="off" />
              <mat-error *ngIf="userCharacteristicsForm.controls.email.hasError('required')" translate>
                field.required
              </mat-error>
              <mat-error
                *ngIf="
                  userCharacteristicsForm.controls.email.invalid &&
                  !userCharacteristicsForm.controls.email.hasError('required')
                "
                translate
              >
                field.error.email
              </mat-error>
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile *ngIf="this.actionUser === 'WB' || userInfoDetail" colspan="9" rowspan="6"></mat-grid-tile>

          <mat-grid-tile *ngIf="this.actionUser === 'WB' || userInfoDetail" colspan="16" rowspan="6" class="text">
            <div>
              <p>
                <strong>{{ 'create.verificate' | translate }}</strong>
              </p>
              <span>{{ 'create.verificate2' | translate }}</span>
            </div>
          </mat-grid-tile>

          <mat-grid-tile *ngIf="this.actionUser === 'WB' || userInfoDetail" colspan="7" rowspan="6">
            <mat-form-field fxFlex="100" fxLayout="column" fxLayoutAlign="center stretch" appearance="outline">
              <mat-label>{{ 'create.password' | translate }}</mat-label>
              <input id="password" formControlName="password" matInput type="password" autocomplete="off" />
            </mat-form-field>
          </mat-grid-tile>
        </div>
      </form>
    </mat-grid-list>
  </mat-card-content>
</mat-card>

<div class="row" class="btnActions">
  <div class="btnLeft">
    <button
      id="cancelId"
      mat-dialog-close
      mat-stroked-button
      class="whitelist-dialog__search"
      *ngIf="this.mode === 'detail' && this.isWebUser"
      [disabled]="!this.userCharacteristicsForm.controls.password.valid"
      color="accent"
      (click)="deleteUser()"
    >
      <mat-icon class="icon-ic_delete_forever"></mat-icon>
      <span>{{ 'create.deleteUser' | translate | uppercase }}</span>
    </button>
  </div>
  <div class="btnRight">
    <button
      id="createUser"
      mat-flat-button
      color="accent"
      *ngIf="this.mode !== 'detail'"
      [disabled]="!userCharacteristicsForm.valid"
      (click)="registerUser()"
    >
      <mat-icon class="icon-ic_save"></mat-icon>
      <span>{{ 'create.createUser' | translate | uppercase }}</span>
    </button>
    <button
      id="editUser"
      mat-flat-button
      color="accent"
      *ngIf="this.mode === 'detail' && this.isWebUser"
      [disabled]="!userCharacteristicsForm.valid"
      (click)="modifyUser()"
    >
      <mat-icon class="icon-ic_save"></mat-icon>
      <span>{{ 'create.saveUser' | translate | uppercase }}</span>
    </button>
  </div>
</div>
